import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import SecurityIcon from '@mui/icons-material/Security';

export function PatrolEmptyState({
  title = "No Patrol Sessions",
  description = "Click 'New Session' in REC Video tab to create your first patrol session entry",
  icon,
}) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        gap: 2,
        p: 4,
      }}
    >
      {icon ?? (
        <SecurityIcon
          sx={{
            fontSize: 80,
            color: "#D1D5DB",
          }}
        />
      )}
      <Typography
        sx={{
          fontFamily: "Roboto, sans-serif",
          fontSize: "16px",
          fontWeight: 600,
          color: "#4A5565",
        }}
      >
        {title}
      </Typography>
      <Typography
        sx={{
          fontFamily: "Roboto, sans-serif",
          fontSize: "14px",
          color: "#6B7280",
          textAlign: "center",
          maxWidth: "400px",
        }}
      >
        {description}
      </Typography>
    </Box>
  );
}

